// extracted by mini-css-extract-plugin
export default {"list":"service-list_list__eO6W6"};